import { Grid, TextField, Button, Alert } from "@mui/material";
import { IApp } from "../../../../../App/Typings/AbacApp";
import useAbacAppDetailsState from "./State/AppDetailsState";
import ListSkeleton from "../../../../../App/Components/Skeleton/ListSkeleton";

interface IAppDetailsProps {
  app: IApp;
}

export function AppDetails({ app }: IAppDetailsProps) {
  const {
    getters: { isActive, formik },
    setters: { setIsActive },
  } = useAbacAppDetailsState(app);

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        {!isActive && (
          <Alert sx={{ mb: { xs: "8%", sm: "1%" } }} severity="error">
            This Application is currently deactivated. All of the Features in
            this application will now appear in their inaccessible state to
            users, and all Attributes created for this Application act as if
            they do not exist.
          </Alert>
        )}
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              fullWidth
              sx={{ mt: "2%" }}
              name="appName"
              label="App Name"
              placeholder="Enter App Name"
              value={formik.values.appName}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.appName)}
              helperText={
                formik.errors.appName ||
                `${formik.values.appName.trim().length}/100`
              }
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              sx={{ mt: "2%" }}
              name="techStack"
              label="Tech Stack"
              placeholder="Enter Tech Stack"
              onChange={formik.handleChange}
              value={formik.values.techStack}
              error={Boolean(formik.errors.techStack)}
              helperText={
                formik.errors.techStack ||
                `${formik.values.techStack.trim().length}/50`
              }
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline
              minRows={5}
              name="appDescription"
              label="Description"
              placeholder="Enter Description"
              onChange={formik.handleChange}
              value={formik.values.appDescription}
              error={Boolean(formik.errors.appDescription)}
              helperText={
                formik.errors.appDescription ||
                `${formik.values.appDescription.trim().length}/500`
              }
            />
          </Grid>
          <Grid container item xs={6}>
            <Button
              color={isActive ? "secondary" : "primary"}
              sx={{ width: { xs: "100%", sm: "50%" } }}
              variant="contained"
              onClick={() => setIsActive(!isActive)}
            >
              {isActive ? "Deactivate Application" : "Activate Application"}
            </Button>
          </Grid>
          <Grid container item justifyContent="flex-end" xs={6}>
            <Button
              sx={{ width: { xs: "100%", sm: "30%" } }}
              variant="contained"
              type="submit"
              disabled={!formik.isValid}
            >
              Save Changes
            </Button>
          </Grid>
        </Grid>
      </form>
    </>
  );
}
